export default __webpack_public_path__ + "static/media/meepels.4287864f.png";